import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ModalService } from '@services/modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-success-threepayments',
  templateUrl: './modal-success-threepayments.component.html',
  styleUrls: ['./modal-success-threepayments.component.scss'],
})
export class ModalSuccessThreepaymentComponent implements OnInit, OnDestroy {
  @Input() approvalCode: string = '123123';

  constructor(public modal: ModalService, private router: Router) {}

  ngOnInit() {}

  ngOnDestroy() {}

  goToStart() {
    this.router.navigateByUrl('/pages/transacciones');
  }
}
